import { render, staticRenderFns } from "./PazienteParametriVitaliPage.vue?vue&type=template&id=2be1fe75"
import script from "./PazienteParametriVitaliPage.vue?vue&type=script&lang=js"
export * from "./PazienteParametriVitaliPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports